// for staging
// const FIREBASE_API_KEY = "AIzaSyCfRxbRrq0_oCxJ8mjxN8T6weAz1chp9OI";

// for production
const FIREBASE_API_KEY = "AIzaSyBTBSuyaKc1RcEDdDxD66uSNFlomItWbkk"



const FIREBASE_AUTH_URL = `https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=${FIREBASE_API_KEY}`;

/**
//  * Validates user credentials WITHOUT creating a persistent session
//  * @param {string} email - User's email
//  * @param {string} password - User's password
//  * @returns {Promise<{isValid: boolean, uid?: string, error?: string}>}
 */

export const validateCredentials = async (email, password) => {
  try {
    const response = await fetch(FIREBASE_AUTH_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: email,
        password: password,
        returnSecureToken: false, // ⬅️ Key parameter: validates only, no session
      }),
    });

    const data = await response.json();

    if (response.ok) {
      // Credentials are valid
      return {
        isValid: true,
        uid: data.localId, // Store this for later actual login
        email: data.email,
        msg: "Credentials are valid",
      };
    } else {
      // Handle specific Firebase error codes
      let errorMessage = "INVALID_LOGIN_CREDENTIALS";

    //   switch (data.error?.message) {
    //     case "INVALID_PASSWORD":
    //       errorMessage = "Invalid password";
    //       break;
    //     case "EMAIL_NOT_FOUND":
    //       errorMessage = "Email not found";
    //       break;
    //     case "USER_DISABLED":
    //       errorMessage = "User account is disabled";
    //       break;
    //     default:
    //       errorMessage = data.error?.message || "Authentication failed";
    //   }

      return {
        isValid: false,
        msg:  ` (${data.error?.message || "Unknown error"})`,
      };
    }
  } catch (error) {
    console.error("Network error during validation:", error);
    return {
      isValid: false,
      error: "Network error. Please check your connection.",
    };
  }
};

/**
 * Alternative function that returns more user info
 */
// export const validateCredentialsWithInfo = async (email, password) => {
//   try {
//     const response = await fetch(FIREBASE_AUTH_URL, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({
//         email: email,
//         password: password,
//         returnSecureToken: true, // Get token for additional info if needed
//       }),
//     });

//     const data = await response.json();

//     if (response.ok) {
//       return {
//         isValid: true,
//         uid: data.localId,
//         email: data.email,
//         idToken: data.idToken, // Available if you need it
//         refreshToken: data.refreshToken,
//       };
//     } else {
//       return {
//         isValid: false,
//         error: data.error?.message || "Authentication failed",
//       };
//     }
//   } catch (error) {
//     return {
//       isValid: false,
//       error: "Network error",
//     };
//   }
// };
